import { Box, Typography, Link, Paper, IconButton } from "@mui/material";
import FacebookIcon from "@mui/icons-material/FacebookTwoTone";
import PersonIcon from "@mui/icons-material/Person";
import PhoneIcon from "@mui/icons-material/Phone";
import Dev_Logo from "../Images/logo/developers_logo_white.png";

const Footer = ({ content, isMobile }) => {
  return (
    <Box>
      <Paper
        elevation={24}
        sx={{
          minHeight: isMobile ? "150px" : "100px",
          borderTopLeftRadius: isMobile ? "0px" : "30px",
          borderTopRightRadius: isMobile ? "0px" : "30px",
          width: "100%",
          position: "relative",
          zIndex: 2,
          backgroundColor: "#333",
          px: { xs: 2, md: 2.5 },
          pt: 3.5,
          display: "grid",
          alignItems: "center",
          gridTemplateColumns: { xs: "1fr", md: "1fr auto 1fr" },
          gridTemplateRows: { xs: "auto auto auto auto", md: "auto" },
          gap: { xs: 1.5, md: 0 },
        }}
      >
        {/* RIGHT: Logo */}
        {/* <Box
          sx={{
            gridColumn: { xs: "1", md: "1" },
            gridRow: { xs: "1", md: "1" },
            justifySelf: { xs: "center", md: "start" },
            pl: { md: 0 }
          }}
        >
          <img
            src={Logo}
            alt={content.footer.alt_logo}
            style={{ height: isMobile ? 60 : 80 }}
          />
        </Box> */}

        {/* CENTER: Copyright + Developed By */}
        <Box
          sx={{
            gridColumn: { xs: "1", md: "2" },
            gridRow: { xs: "2", md: "1" },
            justifySelf: "center",
            textAlign: "center",
            color: "whitesmoke",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 0.5,
          }}
        >
          <Box display="flex" alignItems="center" flexWrap="wrap" justifyContent="center">
            <Typography
              variant="body2"
              fontSize="1.2rem"
              pr={0.5}
              color="#FF0000"
              fontWeight="bold"
              fontStyle="italic"
              sx={{
                textShadow:
                  "0px 0px 5px whitesmoke, 0px 0px 5px whitesmoke, 0px 0px 5px whitesmoke",
              }}
            >
              {content.footer.company_Name.part1}
            </Typography>
            <Typography
              variant="body2"
              fontSize="1.2rem"
              pr={1}
              color="#000000"
              fontWeight="bold"
              fontStyle="italic"
              sx={{
                textShadow:
                  "0px 0px 5px whitesmoke, 0px 0px 5px whitesmoke, 0px 0px 5px whitesmoke",
              }}
            >
              {content.footer.company_Name.part2}
            </Typography>

            <Typography variant="body2" pr={0.5}>
              2024
            </Typography>
            <Typography variant="body2">&copy;</Typography>
            <Typography variant="body2" pl={0.5}>
              Copyrights
            </Typography>
          </Box>

          <Box display="flex" alignItems="center" justifyContent="center">
            <IconButton
              component={Link}
              href="https://lng-websites.github.io/Landing_Page/"
              target="_blank"
              sx={{ p: 0.5 }}
            >
              <img title="LnG" src={Dev_Logo} alt="LnG" style={{ height: 35 }} />
            </IconButton>
            <Typography variant={isMobile ? "mobileBody1" : "body2"}>
              Developed By
            </Typography>
          </Box>
        </Box>

        {/* LEFT: Phone/Email + Facebook */}
        <Box
          sx={{
            gridColumn: { xs: "1", md: "3" },
            gridRow: { xs: "3", md: "1" },
            justifySelf: { xs: "center", md: "end" },
            display: "flex",
            alignItems: "center",
            color: "whitesmoke",
            pr: { md: 2.5 },
          }}
        >
          <Box
            mr={2}
            display="flex"
            flexDirection={isMobile ? "column" : "row"}
            alignItems={isMobile ? "flex-end" : "flex-end"}
            gap={isMobile ? 0.5 : 0}
          >
            <Box display="flex" alignItems="center" sx={{ pr: isMobile ? 0 : "10px" }}>
              <Typography
                sx={{ fontWeight: "bold", fontSize: "1.1rem", color: "white" }}
              >
                {content.phone_number}
              </Typography>
              <PhoneIcon fontSize="medium" />
            </Box>

            <Box display="flex" alignItems="center" sx={{ pr: isMobile ? 0 : "10px" }}>
              <Typography
                sx={{ fontWeight: "bold", fontSize: "1.1rem", color: "white" }}
              >
                {content.email}
              </Typography>
              <PersonIcon fontSize="medium" />
            </Box>
          </Box>

          <IconButton
            size="small"
            color="primary"
            component={Link}
            href={content.href_FBlink}
            target="_blank"
            sx={{
              color: "blue",
              backgroundColor: "whitesmoke",
              "&:hover": { backgroundColor: "whitesmoke" },
            }}
          >
            <FacebookIcon
              fontSize="large"
              sx={{ transform: isMobile ? "scale(1.7)" : "scale(1.7)" }}
            />
          </IconButton>
        </Box>

        {/* Attribution: Images by Freepik & Pexels */}
        <Box
          sx={{
            gridColumn: { xs: "1", md: "1" },
            gridRow: { xs: "4", md: "2" }, // mobile: under everything, desktop: right side
            justifySelf: { xs: "center", md: "start" },
            alignSelf: { md: "end" },
            color: "whitesmoke",
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 0.5,
            // pb: { md: 0.5 },
            pr: { md: 2.5 },
          }}
        >
          <Typography variant={isMobile ? "mobileBody2" : "body2"}>
            <Link
              href={content.footer.freePik.href_Pexelslink}
              target="_blank"
              sx={{ color: "inherit", textDecoration: "underline" }}
            >
              {content.footer.Pexels}
            </Link>
          </Typography>

          <Typography variant={isMobile ? "mobileBody2" : "body2"}>&</Typography>

          <Typography variant={isMobile ? "mobileBody2" : "body2"}>
            <Link
              href={content.footer.freePik.href_FreePiklink}
              target="_blank"
              sx={{ color: "inherit", textDecoration: "underline" }}
            >
              {content.footer.Freepik}
            </Link>
          </Typography>

          <Typography variant={isMobile ? "mobileBody2" : "body2"}>
            {content.footer.freePik.Attribution_Text}
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
};

export default Footer;
